export default "/kiban/_next/static/images/46_12L_other-fe0d7da8f98d9a28446ceaf1a7dd5e6b.png";